export default __webpack_public_path__ + "static/media/ic_location.fcd5ba59.svg";